export interface TableConfig {
  columns: ColumnSetting[]
}

export interface ColumnSetting {
  id: string;
  header: string;
  type?: string;
  props?: any;
  selector: string | string[];
  sortable?: boolean;
  sortingField?: string;
  minWidth?: number;
  linkSetting?: LinkItemSetting;
  operators?: string[];
  defaultOperator?: string;
  filteringKey?: string;
  visibleByDefault?: boolean;
  visible: VisibleOption | string;
  editable?: boolean;
  editType?: 'text' | 'number' | 'select';
  /** For editType 'select'. A plain string renders as both label and value; use {label, value} when the stored value (e.g. a vendor's bulkOrderVendorId) shouldn't be shown to the user as-is. */
  editOptions?: (string | { label: string; value: string })[];
  required?: boolean;
  emptyText?: string;
  /** Marks this column's value as the row's stable identity, for deriveTrackBy. At most one column per table should set this. */
  isIdentity?: boolean;
}

export enum VisibleOption {
  "never" = "never",
  "always" = "always",
  "yes" = "yes",
  "no" = "no"
}
export interface LinkItemSetting {
  url: string;
  idSelector: string;
}

